/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventPostRequestEventData } from './EventPostRequestEventData';
import {
    EventPostRequestEventDataFromJSON,
    EventPostRequestEventDataFromJSONTyped,
    EventPostRequestEventDataToJSON,
    EventPostRequestEventDataToJSONTyped,
} from './EventPostRequestEventData';

/**
 * 
 * @export
 * @interface EventPostRequest
 */
export interface EventPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    analytics_correlation_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    window_location: string;
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    user_agent: string;
    /**
     * 
     * @type {EventPostRequestEventData}
     * @memberof EventPostRequest
     */
    event_data: EventPostRequestEventData;
}

/**
 * Check if a given object implements the EventPostRequest interface.
 */
export function instanceOfEventPostRequest(value: object): value is EventPostRequest {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('analytics_correlation_id' in value) || value['analytics_correlation_id'] === undefined) return false;
    if (!('window_location' in value) || value['window_location'] === undefined) return false;
    if (!('user_agent' in value) || value['user_agent'] === undefined) return false;
    if (!('event_data' in value) || value['event_data'] === undefined) return false;
    return true;
}

export function EventPostRequestFromJSON(json: any): EventPostRequest {
    return EventPostRequestFromJSONTyped(json, false);
}

export function EventPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'analytics_correlation_id': json['analytics_correlation_id'],
        'window_location': json['window_location'],
        'user_agent': json['user_agent'],
        'event_data': EventPostRequestEventDataFromJSON(json['event_data']),
    };
}

export function EventPostRequestToJSON(json: any): EventPostRequest {
    return EventPostRequestToJSONTyped(json, false);
}

export function EventPostRequestToJSONTyped(value?: EventPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'analytics_correlation_id': value['analytics_correlation_id'],
        'window_location': value['window_location'],
        'user_agent': value['user_agent'],
        'event_data': EventPostRequestEventDataToJSON(value['event_data']),
    };
}

